<script setup lang="ts">
import { HLPopover, HLSpace, HLTag } from '@platform-ui/highrise';
import { computed } from 'vue';

interface Props {
    tags: string[]
    tagProps?: any
    spaceProps?: any
    max?: number
    id?: string
}
const props = withDefaults(defineProps<Props>(), {
    max: 3,
})

const generateRestString = computed(() => {
    const count = props.max ? props.tags.length - props.max : null
    return (count > 0 && `+${count}`) || null
})

const canShowTag = (tag, index, max) => {
    return tag && (max ? index < max : true)
}

</script>

<template>
    <HLSpace size="xs">
        <template v-for="(tag, index) in tags" :key="`tags-${index}-${props.id}`">
            <HLTag v-if="canShowTag(tag, index, max)" v-bind="tagProps">
                {{ tag }}
            </HLTag>
        </template>
        <HLPopover trigger="hover" v-if="generateRestString" scrollable>
            <template #trigger>
                <HLTag v-bind="tagProps">
                    {{ generateRestString }}
                </HLTag>
            </template>
            <div class="flex flex-col gap-2 p-2">
                <template v-for="(tag, index) in tags.slice(max)" :key="`tags-rest-${index}-${props.id}`">
                    <HLTag v-bind="tagProps">
                        {{ tag }}
                    </HLTag>
                </template>
            </div>
        </HLPopover>
    </HLSpace>
</template>
